import React from 'react';
import { FeedbackImage, ScrollToTop } from "@core/index";
import { tA11y } from "@utils/a11y/a11yHelpers";
import { appButtonType, appIconsPath } from "@utils/globalConstant";
import useCmsImage from '@utils/useCmsImage';

export const LegitimationSuccess = () => {
  // Const
  const imageContent = useCmsImage("ek_reg_legi_suc_web_bg");
  const headerContent = tA11y("ek_reg_legi_suc_hdl1");
  const copyTextContent = tA11y("ek_reg_legi_suc_txt1");
  const copyText2Content = tA11y("ek_reg_legi_suc_txt2");
  const contentImageContent1 = useCmsImage("ek_reg_legi_badges_chip");
  const contentImageContent2 = useCmsImage("ek_reg_legi_badges_bild");
  const contentImageContent3 = useCmsImage("ek_reg_legi_badges_connect");
    
  return (
    <ScrollToTop>
      <FeedbackImage
        image={imageContent}
        icon={appIconsPath.EMAIL_HAPPY}
        headingContent={headerContent}
        copyTextContent={copyTextContent}
        copyText2Content={copyText2Content}
        contentImages={[contentImageContent1, contentImageContent2, contentImageContent3]}
        // buttonContent={tA11y('ek_reg_legi_suc_btn1')}
        // buttonType={appButtonType.PRIMARY}
      />
    </ScrollToTop>
  );
}

export default LegitimationSuccess;
